import { Sector, Cell, PieChart, Pie } from 'recharts';
import VBox from './VBox';

type Threshold = {
    label: string;
    value: number;
    color: string;
}

type Props = {
    value: number;
    thresholds: Threshold[]
    width?: number;
}
const GaugeChart = ({ value, thresholds, width = 300 }: Props) => {
    const chartValue = value;

    const activeThreshold = thresholds
        .sort((a, b) => a.value - b.value)
        .find(thr => chartValue <= thr.value);

    const maxValue = thresholds[thresholds.length - 1]?.value || 100;


    const arrowData = [
        { value: chartValue },
        { value: 0 },
        { value: (maxValue - chartValue) || 0.1 }
    ];

    const pieProps = {
        startAngle: 180,
        endAngle: 0,
        cx: width / 2,
        cy: width / 2
    };

    const pieRadius = {
        innerRadius: (width / 2) * 0.35,
        outerRadius: (width / 2) * 0.4
    };

    const Arrow = ({ cx, cy, midAngle, outerRadius }) => { //eslint-disable-line react/no-multi-comp
        const RADIAN = Math.PI / 180;
        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);
        const mx = cx + (outerRadius + width * 0.03) * cos;
        const my = cy + (outerRadius + width * 0.03) * sin;
        return (
            <g>
                <circle cx={cx} cy={cy} r={width * 0.02} fill="#444" stroke="none" />
                <path d={`M${cx},${cy}L${mx},${my}`} strokeWidth="6" stroke="#444" fill="none" strokeLinecap="round" />
            </g>
        );
    };

    const ActiveSectorMark = ({ cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill }) => { //eslint-disable-line react/no-multi-comp
        return (
            <g>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius * 1.2}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
            </g>
        );
    };

    const pieData = thresholds.reduce((acc, thr) => {
        const sumPrev = acc.reduce((sum, t) => sum + t.value, 0);
        acc.push({ value: thr.value - sumPrev, color: thr.color });
        return acc;
    }, []);

    return (
        <VBox center style={{ width }}>
            <PieChart width={width} height={(width / 2) + 30}>
                <Pie
                    activeIndex={thresholds.findIndex(thr => thr === activeThreshold)}
                    activeShape={ActiveSectorMark}
                    data={pieData}
                    fill="#8884d8"
                    {...pieRadius}
                    {...pieProps}
                    isAnimationActive={false}
                >
                    {
                        thresholds.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))
                    }
                </Pie>
                <Pie
                    stroke="none"
                    activeIndex={1}
                    activeShape={Arrow}
                    data={arrowData}
                    outerRadius={pieRadius.innerRadius}
                    fill="none"
                    {...pieProps}
                    isAnimationActive={false}
                />
            </PieChart>
            {activeThreshold && (
                <div style={{ textAlign: 'center', width: '100%' }}>
                    <span
                        style={{
                            fontSize: `${Math.round(width * 0.0867)}px`,
                            fontWeight: 'bold',
                            color: activeThreshold.color,
                        }}
                    >{activeThreshold.label}</span>
                </div>
            )}
        </VBox>
    );
};

export default GaugeChart;